<ng-template #loadingModal let-modal>
  <app-loader [loaderStyle]="{height: '100%'}"></app-loader>
</ng-template>

<ng-template #confirmModal let-modal>
    <div class="modal-header justify-content-center">
        <h3 class="fw-semibold">Xác nhận thông tin</h3>
        <app-button [class]="'btn btn-close btn-sm'" [spinner]="false" [id]="'login_modal_close_btn'"
            (click)="onClose()">
            <i class="ri-close-line"></i>
        </app-button>
    </div>
    <div class="p-3">
        <form [formGroup]="form" (ngSubmit)="onConfirm()">
            <div class="d-grid gap-4">
                <h3 class="fw-bold">Giấy chứng nhận đủ điều kiện kinh doanh dược</h3>
                <div class="d-flex row">
                    <div class="col-xxl-4 col-lg-4 col-md-4 col-sm-4 pb-2">
                        <div class="form-floating h-100">
                            <input type="text" class="form-control h-100" id="businessCertificationsNo2"
                                formControlName="businessCertificationsNo" />
                            <label for="businessCertificationsNo2">
                                Số giấy phép
                            </label>
                        </div>
                        <label *ngIf="form.controls['businessCertificationsNo'].touched && form.controls['businessCertificationsNo'].errors?.['required']"
                            class="invalid-feedback">
                            Nhập Số giấy phép
                        </label>
                    </div>
                    <div class="col-xxl-4 col-lg-4 col-md-4 col-sm-4 pb-2">
                        <div class="form-floating h-100">
                            <input class="form-control h-100" placeholder="Ngày cấp" name="dp2"
                                style="width: -webkit-fill-available;" formControlName="businessCertificationsDate" id="businessCertificationsDate2"
                                readonly ngbDatepicker #ds2="ngbDatepicker" (click)="ds2.toggle()"/>
                            <label class="date-picker-label" for="businessCertificationsDate2">
                                Ngày cấp
                            </label>
                        </div>
                        <label *ngIf="form.controls['businessCertificationsDate'].touched && form.controls['businessCertificationsDate'].errors?.['required']"
                            class="invalid-feedback">
                            Nhập Ngày cấp
                        </label>
                    </div>
                    <div class="col-xxl-4 col-lg-4 col-md-4 col-sm-4 pb-2">
                        <div class="form-floating">
                            <textarea type="text" class="form-control" style="height: auto; resize: none;" id="businessCertificationsProvince2"
                                formControlName="businessCertificationsProvince" rows="2"></textarea>
                            <label for="businessCertificationsProvince2">
                                Nơi cấp
                            </label>
                        </div>
                        <label *ngIf="form.controls['businessCertificationsProvince'].touched && form.controls['businessCertificationsProvince'].errors?.['required']"
                            class="invalid-feedback">
                            Nhập Nơi cấp
                        </label>
                    </div>
                </div>
            </div>

            <div>
                <button type="submit" class="btn w-100 mt-3" style="background-color: var(--theme-color); color: #fff;"
                    [disabled]="form.invalid">
                    Xác nhận
                </button>
            </div>
        </form>
    </div>
</ng-template>